import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router"

import { AppShell } from "../components/layout/app-shell"
import "../components/settings/schedules.css"

import { SettingsNav } from "../components/settings/settings-nav"

function SettingsLayout() {
  const pathname = useLocation({ select: (location) => location.pathname })
  if (pathname.startsWith("/settings/schedules")) {
    return (
      <main className="schedule-settings schedule-main">
        <div className="schedule-page">
          {pathname.replace(/\/$/, "") === "/settings/schedules" ? (
            <header className="settings-head">
              <h1 className="page-title">Settings</h1>

              <p className="page-sub">Manage shared Nova control-plane settings.</p>

              <SettingsNav />
            </header>
          ) : null}

          <Outlet />
        </div>
      </main>
    )
  }
  return (
    <AppShell title="Settings" description="Manage shared Nova control-plane settings.">
      <SettingsNav />

      <Outlet />
    </AppShell>
  )
}

export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
})
